"use client";

import { useEffect } from "react";
import {
  getSettledSearchPage,
  shouldLoadMoreSearchResults,
} from "./listing-browse-query";

const SEARCH_SCAN_PAGE_SIZE = 100;

type SearchPaginationStatus =
  "LoadingFirstPage" | "CanLoadMore" | "LoadingMore" | "Exhausted";

export function useSearchResultPagination(args: {
  hasSearch: boolean;
  status: SearchPaginationStatus;
  resultCount: number;
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  loadMore: (numItems: number) => void;
}): number {
  const { hasSearch, status, resultCount, page, pageSize, setPage, loadMore } =
    args;
  const settledPage = getSettledSearchPage({
    hasSearch,
    status,
    resultCount,
    currentPage: page,
    pageSize,
  });
  if (settledPage !== page) setPage(settledPage);

  const requiredResultCount = page * pageSize;
  useEffect(() => {
    if (
      shouldLoadMoreSearchResults({
        hasSearch,
        status,
        resultCount,
        requiredResultCount,
      })
    ) {
      loadMore(SEARCH_SCAN_PAGE_SIZE);
    }
  }, [hasSearch, loadMore, requiredResultCount, resultCount, status]);

  return requiredResultCount;
}
